import { Injectable, Injector, NgZone, OnDestroy } from '@angular/core';
import { AuthService } from "@carm/_auth/spartacus/core/auth";
import { BaseApiService } from "@carm/_core/baseapi.service";
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { IDeployment } from "../models/deployment-model";

@Injectable()
export class DeploymentTimeoutService extends BaseApiService implements  OnDestroy {

  private interval: any;
  private destroy$ = new Subject<void>();
  private updateNextDeploymentTime$ = new BehaviorSubject(<{valid :boolean}>({valid: false}));

  deploymentWarningSettings = {
    nextDeploymentPooling: environment.deploymentWarningSettings?.nextDeploymentPooling
      ? environment.deploymentWarningSettings?.nextDeploymentPooling : 5,
  };

  constructor(protected injector: Injector, protected authService: AuthService, private ngZone: NgZone) {
    super(injector);
    this.authService.isUserLoggedIn().subscribe(isUserLoggedIn => {
      if(isUserLoggedIn){
        this.fetchDeploymentTime();
      }
    });
  }


  public startFetchingDeploymentTime() {
    if(this.interval) {
      clearInterval(this.interval);
    }

    this.fetchDeploymentTime(); // Initial call

    this.ngZone.runOutsideAngular(() => {
      this.interval = setInterval(() => this.fetchDeploymentTime(), 60 * this.deploymentWarningSettings.nextDeploymentPooling * 1000); // 5 minutes
    })
  }


  public fetchDeploymentTime() {
    const endpoint = `${environment.baseApiUrls}/deployment/time`;
    this.httpGet<IDeployment>(endpoint)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          if(response.deploymentTime)
          {
            const nextDeploymentTime = Date.now() + response.deploymentTime;
            const deploymentDate = new Date(nextDeploymentTime);

            // Save deployment time in  LocalStorage
            localStorage.setItem('nextDeploymentTime', deploymentDate.toISOString());

            this.updateNextDeploymentTime$.next({ valid: true });
          } else {

            // Remove invalid deployment time
            localStorage.removeItem('nextDeploymentTime');
            this.updateNextDeploymentTime$.next({ valid: false });
          }
        },
        (error) => {
          console.error('Error fetching deployment time:', error);
        }
      );
  }

  public isNextDeploymentTimeUpdated(): BehaviorSubject<{ valid: boolean }>{
    return this.updateNextDeploymentTime$;
  }


  ngOnDestroy() {
    clearInterval(this.interval);
    this.destroy$.next();
    this.destroy$.complete();
  }
}
